import { useMemo, useState } from 'react';

import { SingleSelectOption } from './single-select-types';

export function useSelectState({
  onOpenChange,
  onSearchChange,
}: {
  onOpenChange?: (open: boolean) => void;
  onSearchChange?: (value: string) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (!open) {
      setSearchValue('');
      onSearchChange?.('');
    }
    onOpenChange?.(open);
  };

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
    onSearchChange?.(value);
  };

  return {
    isOpen,
    searchValue,
    handleOpenChange,
    handleSearchChange,
  };
}

export function useFilteredOptions({
  options,
  searchValue,
  searchable,
  enableClientSideFiltering,
}: {
  options: SingleSelectOption[];
  searchValue: string;
  searchable: boolean;
  enableClientSideFiltering: boolean;
}) {
  return useMemo(() => {
    if (!searchable || !searchValue.trim() || !enableClientSideFiltering) {
      return options;
    }

    const searchTerm = searchValue.toLowerCase();
    return options.filter(option => {
      return (
        option.label.toLowerCase().includes(searchTerm) ||
        (option.description && option.description.toLowerCase().includes(searchTerm)) ||
        (option.searchValue && option.searchValue.toLowerCase().includes(searchTerm))
      );
    });
  }, [options, searchValue, searchable, enableClientSideFiltering]);
}
